export interface Offer {
  accepted: string;
  acceptedByUserId: boolean | null;
  advanceRate: string | number | null;
  amount: string | number;
  apiLogId: number;
  apiLogTableId: number | null;
  applicationId: number;
  apr?: string | number;
  borrowerAccepted: boolean | null;
  borrowerDeclined: boolean | null;
  buyRate: string | number | null;
  commission: string | number;
  created: string;
  createdTimestamp: number;
  creditCardHoldback: string | number | null;
  cost?: string | number;
  costType?: string;
  deadDispositionId: number | null;
  dealId: number;
  declined: string | null;
  declinedByUserId: boolean | null;
  declinedOtherReason: string | null;
  declinedReason: string | null;
  deleted: string | null;
  documentIds: number[] | string[];
  expiration: string | Date | null;
  factor?: string | number | null;
  grossSalesHoldback: string | number | null;
  housePoints: string | number | null;
  id: number;
  inputLenderId: number | null;
  inputLenderUserId: number;
  interestRate: string | number | null;
  lenderName: string;
  lenderOfferId: number | null;
  loanProductType: string;
  minPurchaseFee: string | number | null;
  modified: string;
  modifiedTimestamp: number;
  name: string  | null;
  netFundedAmount: string | number | null;
  notes: string | null;
  numPayments: number;
  offerLink: string | null;
  originationFee: string | number | null;
  payback: string | number | null;
  paymentAmount: string | number | null;
  paymentFrequency: string;
  paymentTerm: string | number | null;
  points: string | number | null;
  position: number | null;
  publishedByLenderUserId: number;
  publishedToBorrower: string;
  received: string | Date;
  term: number;
  type: string;
  url: string | null;
  expanded?: boolean;
  calculatedFields: any;
  isCreatedByFundingDesk?: boolean;
}

export const paymentFrequencies = {
  'daily': {
    index: 0,
    display: 'Daily',
    value: 'daily'
  },
  'semiweekly': {
    index: 1,
    display: 'Semi-Weekly',
    value: 'semiweekly'
  },
  'weekly': {
    index: 2,
    display: 'Weekly',
    value: 'weekly'
  },
  'biweekly': {
    index: 3,
    display: 'Bi-Weekly',
    value: 'biweekly'
  },
  'semimonthly': {
    index: 4,
    display: 'Semi-Monthly',
    value: 'semimonthly'
  },
  'monthly': {
    index: 5,
    display: 'Monthly',
    value: 'monthly'
  },
  'bimonthly': {
    index: 6,
    display: 'Bi-Monthly',
    value: 'bimonthly'
  }
};

export const paymentTerms = {
  'net 15': {
    index: 0,
    display: 'Net 15',
    value: 'net 15'
  },
  'net 30': {
    index: 1,
    display: 'Net 30',
    value: 'net 30'
  },
  'net 40': {
    index: 2,
    display: 'Net 40',
    value: 'net 40'
  },
  'net 50': {
    index: 3,
    display: 'Net 50',
    value: 'net 50'
  },
  'net 60': {
    index: 4,
    display: 'Net 60',
    value: 'net 60'
  },
  'net 70': {
    index: 5,
    display: 'Net 70',
    value: 'net 70'
  },
  'net 80': {
    index: 6,
    display: 'Net 80',
    value: 'net 80'
  },
  'net 90': {
    index: 7,
    display: 'Net 90',
    value: 'net 90'
  },
  'net 90+': {
    index: 8,
    display: 'Net 90+',
    value: 'net 90+'
  }
};

export const offerStatuses = {
  'draft': {
    value: 'draft',
    display: 'Draft',
  },
  'published': {
    value: 'published',
    display: 'Published',
  },
  'accepted': {
    value: 'accepted',
    display: 'Accepted',
  },
  'contractRequested': {
    value: 'contractRequested',
    display: 'Contract Requested',
  },
  'declined': {
    value: 'declined',
    display: 'Declined',
  },
};
